/*eslint-disable*/
import React from 'react';
import { Link } from 'react-router-dom';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// nodejs library that concatenates classes
import classNames from 'classnames';
// material-ui core components
import { List, ListItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// @material-ui/icons
import Favorite from '@material-ui/icons/Favorite';

import styles from 'assets/jss/material-kit-react/components/footerStyle.js';
import {
  HOME,
  LOGIN,
  REGISTER,
  DASHBOARD,
  MY_POSTS,
  LIVE_STREAM,
} from 'constants/routes';
import { shallowEqual, useSelector } from 'react-redux';
import { CREATE_STREAM } from 'constants/routes';

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const {
    auth: { isAuthenticated, user },
  } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  }, shallowEqual);

  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            {!isAuthenticated || user === null ? (
              <>
                <ListItem className={classes.inlineBlock}>
                  <Link
                    to={HOME}
                    style={{ textDecoration: 'none', color: '#3C4858' }}
                    className={classes.block}
                  >
                    Home
                  </Link>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <Link
                    to={LOGIN}
                    style={{ textDecoration: 'none', color: '#3C4858' }}
                    className={classes.block}
                  >
                    LOGIN
                  </Link>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <Link
                    to={REGISTER}
                    style={{ textDecoration: 'none', color: '#3C4858' }}
                    className={classes.block}
                  >
                    REGISTER
                  </Link>
                </ListItem>
              </>
            ) : (
              <>
                <ListItem className={classes.inlineBlock}>
                  <Link
                    to={DASHBOARD}
                    style={{ textDecoration: 'none', color: '#3C4858' }}
                    className={classes.block}
                  >
                    Dashboard
                  </Link>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <Link
                    to={MY_POSTS}
                    style={{ textDecoration: 'none', color: '#3C4858' }}
                    className={classes.block}
                  >
                    My Posts
                  </Link>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  {!user.isLive ? (
                    <Link
                      to={CREATE_STREAM}
                      style={{ textDecoration: 'none', color: '#3C4858' }}
                      className={classes.block}
                    >
                      Live Stream
                    </Link>
                  ) : (
                    <Link
                      to={`${DASHBOARD}/user/streams/watch/${user.liveStreamInfo.streamKey}`}
                      style={{ textDecoration: 'none', color: '#3C4858' }}
                      className={classes.block}
                    >
                      Live Stream
                    </Link>
                  )}
                </ListItem>
              </>
            )}
          </List>
        </div>
        <div className={classes.right}>
          Gamers world, &copy; {1900 + new Date().getYear()}
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool,
};
